// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"100":"771d7bf8","605":"ab4a27f1"}[chunkId] + ".chunk.css";
};